import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import { formatCurrencyEur } from '../../../../Helper/formatter';
import DepositImage from '../../../../../../public/images/pfand_img.webp';
import styles from './ProductSizeInformation.module.scss?module';
import clsx from 'clsx';
import DepositInfo from '../../../Products/Abstracts/DepositInfo/DepositInfo';

const ProductSizeInformation = ({
  product_size,
}: {
  product_size: ProductSizeInterface;
}) => {
  return (
    <div>
      <div className="small">
        <span className="fw-bold">Category: </span>
        <span>{product_size.category?.name}</span>
      </div>
      <div className="small">
        <span className="fw-bold">Size: </span>
        <span>{`${product_size.unit_value} ${product_size.unit_name}`}</span>
      </div>
      {product_size.msrp > 0 && (
        <div className="small">
          <span className="fw-bold">MSRP: </span>
          <span>{formatCurrencyEur(product_size.msrp)}</span>
        </div>
      )}
      {product_size.single_deposit_price > 0 &&
      product_size.deposit_units_count > 0 ? (
        <div className="d-flex align-items-center">
          <img
            className={styles.depositImage}
            src={DepositImage}
            alt="deposit_image"
          />
          <DepositInfo
            unitsCount={product_size.deposit_units_count}
            price={product_size.single_deposit_price}
            className={clsx(styles.depositText, 'small')}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ProductSizeInformation;
